<div class="number-info">
  <ngx-charts-number-card
    class="chart-container"
    [view]="view"
    cardColor="#2D323E"
    [scheme]="'air'"
    [results]="data"
    [animations]="animations">
  </ngx-charts-number-card>
</div>
